module.exports = __webpack_public_path__ + "static/engBG-aea780347a3d7f064583e2fc0d4cdfc1.jpg";